<section>
  <div class="pull-right edit-bar">
  </div>
  <div class="all-content">
    <div class="center-content">
      <div class="editable-header-box">
        <div class="editable-header">
          <div class="editable-header-content-wrapper">
            <h4>{{purposeTitle}}</h4>
            <ng-container *ngIf="canEdit">
              <app-edit-overlay [isPlaceholder]="isPurposePlaceholder"
                                [isEditor]="canEdit"
                                (planCoordinateChange)="onPlanCoordinateChangePurposeMissionBeliefs()">
                <p class="strategy-map-header" [innerHTML]="purposeDescription"></p>
              </app-edit-overlay>
            </ng-container>
            <ng-container *ngIf="!canEdit">
              <p [innerHTML]="purposeDescription"></p>
            </ng-container>
          </div>
        </div>
        <div class="editable-header">
          <div class="editable-header-content-wrapper">
            <h4>{{missionTitle}}</h4>
            <ng-container *ngIf="canEdit">
              <app-edit-overlay [isPlaceholder]="isMissionPlaceholder"
                                [isEditor]="canEdit"
                                (planCoordinateChange)="onPlanCoordinateChangePurposeMissionBeliefs()">
                <p class="strategy-map-header" [innerHTML]="missionDescription"></p>
              </app-edit-overlay>
            </ng-container>
            <ng-container *ngIf="!canEdit">
              <p [innerHTML]="missionDescription"></p>
            </ng-container>
          </div>
        </div>
        <div class="editable-header">
          <div class="editable-header-content-wrapper">
            <h4>{{beliefsTitle}}</h4>
            <ng-container *ngIf="canEdit">
              <app-edit-overlay [isPlaceholder]="isBeliefsPlaceholder"
                                [isEditor]="canEdit"
                                (planCoordinateChange)="onPlanCoordinateChangePurposeMissionBeliefs()">
                <p class="strategy-map-header" [innerHTML]="beliefsDescription"></p>
              </app-edit-overlay>
            </ng-container>
            <ng-container *ngIf="!canEdit">
              <p [innerHTML]="beliefsDescription"></p>
            </ng-container>
          </div>
        </div>
      </div>
      <section>
        <div class="stack-container">
          <app-priority-stack-header
            [priorities]="pagePriorities"
            [placeholderColor]="placeholderColor"
            (planCoordinateChange)="onPlanCoordinateChange($event)"
            [pageIndex]="pageIndex"
            [hasFullPriorityList]="hasFullPriorityList"
          ></app-priority-stack-header>
          <div class="carousel-button-container">
            <button *ngIf="decrementPageVisible" class="carousel-nav-button carousel-nav-button-left fa fa-angle-left"
                    (click)="decrementPage()"></button>
            <div class="carousel-button-spacer"></div>
            <button *ngIf="incrementPageVisible" class="carousel-nav-button carousel-nav-button-right fa fa-angle-right"
                    (click)="incrementPage()"></button>
          </div>
          <app-priority-stack-section
            [priorities]="pagePriorities"
            [permissions]="permissions"
            [placeholderColor]="placeholderColor"
            [heading]="headings.objectiveHeading"
            [dataKey]="objectivesDataKey"
            [dataValueKey]="objectivesDataValueKey"
            [sectionPosition]="objectivesSectionPosition"
            (planCoordinateChange)="onPlanCoordinateChange($event)"
            [targetCoordinate]="creatingObjectivesCoordinate"
            [pageIndex]="pageIndex"
            [hasFullPriorityList]="hasFullPriorityList"
          >
          </app-priority-stack-section>
          <app-priority-stack-section
            [priorities]="pagePriorities"
            [permissions]="permissions"
            [placeholderColor]="placeholderColor"
            [heading]="headings.initiativeHeading"
            [dataKey]="initiativesDataKey"
            [dataValueKey]="initiativesDataValueKey"
            [sectionPosition]="initiativesSectionPosition"
            (planCoordinateChange)="onPlanCoordinateChange($event)"
            [targetCoordinate]="creatingObjectivesCoordinate"
            [pageIndex]="pageIndex"
            [hasFullPriorityList]="hasFullPriorityList"
          >
          </app-priority-stack-section>
          <app-priority-stack-section
            [priorities]="pagePriorities"
            [permissions]="permissions"
            [placeholderColor]="placeholderColor"
            [heading]="headings.keyMeasureHeading"
            [dataKey]="keyMeasuresDataKey"
            [dedupeByKey]="keyMeasureDedupeKey"
            [dataValueKey]="keyMeasuresDataValueKey"
            [sectionPosition]="keyMeasuresSectionPosition"
            (planCoordinateChange)="onPlanCoordinateChange($event)"
            [targetCoordinate]="identifyOutcomesAndKeyMeasures"
            [pageIndex]="pageIndex"
            [hasFullPriorityList]="hasFullPriorityList"
          >
          </app-priority-stack-section>
        </div>
      </section>
    </div>
  </div>
  <button auto="back-to-planning-strat-map" class="btn btn-primary btn-back-to-planning"
          (click)="onPlanCoordinateChangeDevelopStrategyMap()">Back to Planning</button>
</section>
